import React from 'react';
import {
    Box,
    Text,
    VStack,
    HStack,
    Button,
    Badge,
    Center,
} from '@chakra-ui/react';
import { useAuction } from '../context/AuctionContext';
import CountdownTimer from './CountdownTimer';
import { getDayStartDate } from '../utils/timerUtils';
import { FaTwitter } from 'react-icons/fa';
import { TOTAL_AUCTION_TOKENS } from '../utils/constants';

const DexListingBox = ({
    totalDexUsers,
    totalDexSol,
    totalUserJinu,
    handleTwitterShare,
    handleDayClick
}) => {
    const TOTAL_JINU_SUPPLY = TOTAL_AUCTION_TOKENS;

    const formatNumber = (num) => {
        // Handle undefined, null, or NaN values
        if (num === undefined || num === null || isNaN(num)) {
            return '0';
        }
        
        if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`;
        if (num >= 1000) return `${(num / 1000).toFixed(1)}K`;
        return num.toFixed(2);
    };

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    };
    
    return (
        <Box
            position="relative"
            bg="linear-gradient(135deg, #1a365d 0%, #2d3748 100%)"
            borderWidth="1px"
            borderColor="blue.400"
            borderRadius="xl"
            p={4}
            transition="all 0.2s"
            _hover={{
                transform: 'translateY(-2px)',
                boxShadow: 'xl'
            }}
            height="0"
            paddingBottom="100%"
            overflow="hidden"
            sx={{
                '@keyframes pulse': {
                    '0%': { transform: 'scale(1)' },
                    '50%': { transform: 'scale(1.2)' },
                    '100%': { transform: 'scale(1)' }
                },
                '.pulse-emoji': {
                    display: 'inline-block',
                    animation: 'pulse 2s infinite'
                }
            }}
        >
            <VStack
                position="absolute"
                top="0"
                left="0"
                right="0"
                bottom="0"
                p={4}
                spacing={2}
                align="stretch"
            >
                {/* Day & Timer */}
                <HStack justify="space-between" align="center">
                    <Text color="white" fontSize="md" fontWeight="bold">
                        Day 51
                    </Text>
                    <CountdownTimer 
                        targetDate={getDayStartDate(51)} 
                        mode="compact"
                        fontSize="xs"
                        color="white"
                    />
                </HStack>

                {/* Date & Status */}
                <HStack justify="space-between" align="center">
                    <Text fontSize="xs" color="gray.400">
                        {formatDate(getDayStartDate(51))}
                    </Text>
                    <Text color="green.400" fontWeight="bold" fontSize="xs">
                        GO FLIGHT <span className="pulse-emoji">✈️</span>
                    </Text>
                </HStack>

                {/* Total Users */}
                <HStack justify="space-between" align="center">
                    <Text fontSize="xs" color="gray.400">
                        Total Users: {formatNumber(totalDexUsers)}
                    </Text>
                </HStack>

                {/* Centered Total SOL with Solana Logo */}
                <Center flex={1}>
                    <VStack spacing={1}>
                        <HStack spacing={2} align="center">
                            <Box as="img" src="/Solana-Logo 2.svg" alt="SOL" w="24px" h="24px" />
                            <Text fontSize="2xl" fontWeight="bold" color="white">
                                {formatNumber(totalDexSol)}
                            </Text>
                        </HStack>
                        <Text fontSize="sm" color="gray.400">Total SOL Collected</Text>
                    </VStack>
                </Center>

                {/* User's Total JINU */}
                <Box 
                    width="100%" 
                    p={2} 
                    bg="whiteAlpha.100" 
                    borderRadius="md"
                    mt="auto"
                >
                    <VStack spacing={1} align="center">
                        <Text fontSize="sm" color="blue.200">
                            Your Total: {formatNumber(totalUserJinu)} JINU
                        </Text>
                        <Text fontSize="xs" color="gray.400">
                            Share: {totalUserJinu && TOTAL_JINU_SUPPLY ? ((totalUserJinu / TOTAL_JINU_SUPPLY) * 100).toFixed(2) : '0.00'}%
                        </Text>
                    </VStack>
                </Box>

                {/* Buttons Container */}
                <VStack spacing={2} width="100%">
                    <Button
                        variant="outline"
                        colorScheme="blue"
                        size="sm"
                        width="100%"
                        borderRadius="full"
                        onClick={() => alert("Claim Day is Coming!")}
                        _hover={{
                            bg: "blue.500",
                            color: "white"
                        }}
                        transition="all 0.2s"
                    >
                        Claim
                    </Button>

                    <Center width="100%">
                        <Button
                            leftIcon={<FaTwitter />}
                            size="xs"
                            colorScheme="twitter"
                            variant="ghost"
                            onClick={handleTwitterShare}
                            fontSize="xs"
                            px={2}
                            height="24px"
                            width="auto"
                            borderRadius="full"
                            _hover={{ 
                                color: '#1DA1F2'
                            }}
                        >
                            Share & Get 10% More!
                        </Button>
                    </Center>
                </VStack>
            </VStack>
        </Box>
    );
};

export default DexListingBox;
